export interface WorkspaceMemberFilter {
  searchFor?: string;
  exactMatch?: boolean;
  roles?: Array<String>;
  location?: string;
  states?: Array<string>;
  page?: number;
  pagesize?: number;
  order?: string;
  direction?: number;
}

export const defaultWorkspaceMemberFilterState: WorkspaceMemberFilter = {
  searchFor: '',
  exactMatch: false,
  roles: [],
  location: 'All',
  states: [],
  page: 1,
  pagesize: 24,
  order: 'email',
  direction: 1
};
